import ScanHeader from './ArrivalScanPanel/ScanHeader';
import ScanInput from './ArrivalScanPanel/ScanInput';
import React from 'react';

interface ArrivalScanPanelProps {
  inputValue: string;
  setInputValue: (val: string) => void;
  onKeyDown: (e: React.KeyboardEvent) => void;
  isLoading: boolean;
  inputRef: React.RefObject<HTMLInputElement>;
}

const ArrivalScanPanel = ({
  inputValue,
  setInputValue,
  onKeyDown,
  isLoading,
  inputRef,
}: ArrivalScanPanelProps) => {
  return (
    <div className='bg-white rounded-xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-gray-100 p-8'>
      <ScanHeader />
      <ScanInput 
        inputValue={inputValue}
        setInputValue={setInputValue}
        onKeyDown={onKeyDown}
        isLoading={isLoading}
        inputRef={inputRef}
      />
    </div>
  );
};

export default ArrivalScanPanel;
